import { useEffect } from "react";

export const TimelessBeauty = ({ onClose }) => {
    useEffect(() => {
        // Function to handle keydown event
        const handleKeyDown = (event) => {
            if (event.key === "Escape") {
                onClose(); // Call the onClose function when Esc is pressed
            }
        };

        // Add event listener when the component mounts
        window.addEventListener("keydown", handleKeyDown);

        // Clean up event listener when the component unmounts
        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [onClose]);

    return (
        <>
            <div
                className="modal"
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    overflowY: "auto", // Enable scrolling for the modal
                    zIndex: 1050,

                }}
            >
                <div
                    className="modal-content"
                    style={{
                        padding: "20px",
                        background: "#fff",
                        borderRadius: "8px",
                        maxWidth: "500px",
                        width: "95%",
                        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.3)",
                        maxHeight: "95vh", // Limit the modal height to viewport
                        overflowY: "auto", // Enable content scrolling within the modal
                    }}
                >
                    <div className="img-fluid mb-4">
                        <picture>
                            <img
                                src="/media/poemseng/timeless-beauty.jpg"
                                alt=" Timeless Beauty | Lone Wolf writes "
                                style={{
                                    width: "100%",
                                    height: "18rem",
                                    objectFit: "cover",
                                    borderRadius: "6px",
                                    backgroundColor: "gray",
                                }}
                            />
                        </picture>
                    </div>

                    <h2 style={{ textAlign: "center", color:"red" }}>Timeless Beauty</h2>
                    <hr />

                    <p style={{ textAlign: "center" }}>
                        A vision of beauty, she enters the room<br />
                        Her hair, a cascade of golden light<br />
                        Her eyes, like pools of crystal blue<br />
                        Her lips, soft and invitingly bright<br />
                        <br />
                        Her cheeks, a rosy hue of dawn<br />
                        A gentle smile, like the morning sun<br />
                        Her heart, pure as a white swan<br />
                        A grace and charm that can't be undone<br />
                        <br />
                        With each movement, she captivates<br />
                        A siren's call, impossible to ignore<br />
                        Her beauty, a sight to celebrate<br />
                        Her heart, a treasure to adore<br />
                        <br />
                        In her, the world finds solace<br />
                        A beacon of hope, a symbol of love<br />
                        She is the embodiment of grace<br />
                        A gift from the heavens above<br />
                        <br />
                        Her beauty, a timeless wonder<br />
                        A rare gem that shines with pride<br />
                        Her heart, a priceless treasure<br />
                        A beauty that cannot be denied<br /><br />
                    </p>

                    <div className="modal-footer" style={{ textAlign: "right" }}>
                        <button type="button" onClick={onClose} className="btn btn-secondary" style={{ backgroundColor: "red", border: 0, padding: "10px 20px", color: "#fff", borderRadius: "5px", }}>
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};
